import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07ce4e30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "footer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "footer" }

import { computed } from "vue";
import { Button, message } from "ant-design-vue";
import CusModal from "@/components/CusModal/index.vue";
import { gameWind } from "@js/game/game-window";
import { PlayGameInterceptChain } from "@js/game/game-intercept";
import * as Accounts from "@js/account";
import { usePlayGameStore } from "@/store/playGame";


export default /*#__PURE__*/_defineComponent({
  __name: 'ExitControl',
  setup(__props) {

const playGameStore = usePlayGameStore();

const isShow = computed(() => playGameStore.exitModal);
const exitData = computed(() => playGameStore.exitData);
const isExiting = computed(() => playGameStore.isExiting);

// 确定切换游戏
const handleOk = () => {
  if (
    !Accounts.getRTCConnected() &&
    Number(Accounts.getIsPlayingGame()) > 0 &&
    gameWind &&
    !gameWind.closed
  ) {
    message.error(
      "The cloud game is being connected, please try again later！"
    );
  } else {
    // PlayGameInterceptChain.nextIntercept &&
    //   PlayGameInterceptChain.nextIntercept.intercept();
    window.gameStateMgr.reQueueGame();
  }
};

// 取消切换游戏
const handleCancel = () => {
  playGameStore.handleCancelExit();
};

// 继续游戏，不退出游戏
const handleBack = () => {
  playGameStore.exitModal = false;
  playGameStore.isExiting = false;
};

// 退出游戏
const handleExit = () => {
  window.gameStateMgr.exitGame();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CusModal, {
    isShow: _unref(isShow),
    width: "480px",
    keyboard: false,
    centered: "",
    onOnClose: _cache[0] || (_cache[0] = () => (_unref(isExiting) ? handleBack() : handleCancel()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_unref(isExiting))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Control.ExitControl.content")), 1)
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "mgr active-btn",
                  onClick: handleBack
                }, _toDisplayString(_ctx.$t("Control.ExitControl.payForWhile")), 1),
                _createElementVNode("div", {
                  class: "ok-btn active-btn",
                  onClick: handleExit
                }, _toDisplayString(_ctx.$t("Control.ExitControl.exitIme")), 1)
              ])
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Control.ExitControl.gameRunning")), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t("Control.ExitControl.swithTo")) + " " + _toDisplayString(_unref(exitData).to), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", {
                  class: "mgr active-btn",
                  onClick: handleCancel
                }, _toDisplayString(_ctx.$t("Control.ExitControl.Cancle")), 1),
                _createElementVNode("div", {
                  class: "ok-btn active-btn",
                  onClick: handleOk
                }, _toDisplayString(_ctx.$t("Control.ExitControl.OK")), 1)
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["isShow"]))
}
}

})